import ProjectOverviewCard from '@/shared/ui/project-overview-card';
import DescriptionEditor from '@/shared/ui/description-editor';
import {
  Calendar,
  DollarSign,
  Clock,
  MapPin,
} from 'lucide-react';
import {Project} from '@/shared/types/api';
import ProjectHeader from '@/shared/ui/project-header';
import {format} from 'date-fns';

interface ParticipantProjectViewProps {
  project: Project;
}

export default function ParticipantProjectView({ project }: Readonly<ParticipantProjectViewProps>) {
  // Format dates
  const formatDateRange = () => {
    if (project.start_date && project.end_date) {
      return `${format(new Date(project.start_date), 'MMM d, yyyy')} - ${format(new Date(project.end_date), 'MMM d, yyyy')}`;
    } else if (project.start_date) {
      return `Starts ${format(new Date(project.start_date), 'MMM d, yyyy')}`;
    } else if (project.end_date) {
      return `Ends ${format(new Date(project.end_date), 'MMM d, yyyy')}`;
    }
    return 'Not specified';
  };

  return (
    <div className="space-y-6">
      <ProjectHeader
        title={project.name}
        description={'Research study overview and details'}
        showStatus={true}
        status={
          (project.status as 'active' | 'inactive' | 'completed' | 'draft') ||
          'inactive'
        }
      >
        {/* No edit actions for participants */}
      </ProjectHeader>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <ProjectOverviewCard
          icon={<Calendar color="#fff" />}
          label="Project Dates"
          value={formatDateRange()}
          isEditable={false}
          onChange={() => {}}
        />
        <ProjectOverviewCard
          icon={<DollarSign color="#fff" />}
          label="Compensation"
          value={project.compensation || 'Not specified'}
          isEditable={false}
          onChange={() => {}}
        />
        <ProjectOverviewCard
          icon={<Clock color="#fff" />}
          label="Time Commitment"
          value={project.time_commitment || 'Not specified'}
          isEditable={false}
          onChange={() => {}}
        />
        <ProjectOverviewCard
          icon={<MapPin color="#fff" />}
          label="Location"
          value={project.location || 'Not specified'}
          isEditable={false}
          onChange={() => {}}
        />
      </div>

      <DescriptionEditor
        value={project.description || ''}
        title="Description"
        isEditable={false}
        onChange={() => {}}
        onTitleChange={() => {}}
        placeholder=""
      />

      {/* Sections */}
      {project.sections && Array.isArray(project.sections) && project.sections.map((section: any) => (
        <div key={section.id}>
          <DescriptionEditor
            value={section.content || ''}
            title={section.title || 'Section'}
            isEditable={false}
            onChange={() => {}}
            onTitleChange={() => {}}
            placeholder=""
            showDeleteButton={false}
          />
        </div>
      ))}
    </div>
  );
}

